<template>
  <TableTemplate class="OverviewOrder"
                 :value="mappedOrders"

                 :columns="tableColumns"
                 :columnVariables="tableColumnVariables"
                 :capitalize="capitalize"
                 :skeletonClass="skeletonClass"

                 :page="page"
                 :max="max"
                 :enable-sorting="true"
                 :remove-cursor="true"

                 @update-column-order="updateColumnOrder"
                 @set-page="v => page = v"
                 :on-row-click="viewOrder"

                 ref="table"
  >
    <template #above>
      <TableHeader
        class="px-12 table-header-res"
        title="Bestellingen"
        :alwaysShowMultiSelectCheckbox="false"
        :refetch="refetch"
        :exportParams="exportEndpointParams"

        csv-name="orders"
        export-endpoint="/api/orders/export"
        @setting-layout="customizeSetting"
        @customize-layout="customizeLayout"
      >
        <template #after-title>
          <HeaderButton
            class="ml-2"
            buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
            style="padding: 11px 8px"
            @click.native="addOrder"
          >
            Nieuwe bestelling
          </HeaderButton>
        </template>
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>

          <!-- Show Filter Button -->
<!--          <div leave-class="d-flex align-items-center">
            <button class="btn btn-secondary filter-button mr-2" @click="_showFilters">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
                <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><path d="M13.5.5H.5a6.51,6.51,0,0,0,5,6.33V13.5l3-2V6.83A6.51,6.51,0,0,0,13.5.5Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path></g>
              </svg>

              {{ !showFilters ? "Filters tonen" : "Verberg filters" }}
            </button>
          </div>-->
        </template>
      </TableHeader>
      <div>
        <OrderListSummary
          :initial_date.sync="orderInitialDate"
          :final_date.sync="orderFinalDate"
          :site="site"

          :total-price-of-products="totalPriceOfProducts"
          :average-products-per-order="averageProductsPerOrder"
        />

      </div>
      <div class="d-flex justify-content-between p-12 table-header-res">
        <div class="d-flex">
          <TableMainSearchField v-model="search"/>
          <FormSearchSelector
            v-model="site"
            class="ml-2 website-search"
            id="website"
            placeholder="Zoek website..."
            endpoint="/api/websites"
            titleField="domainname"
            searchParameter="name"
            @select-item="setWebsiteParam"

            :infinite-scrolling="true"
            :table="true"

            v-slot="item"
          >
            <div class="p-1 item">
              {{ item.domainname }}
            </div>
          </FormSearchSelector>

        </div>
        <div>
          <MultiplePageSizesSelection
            v-model="page_size"
            :available-values="availablePageSizeValues"
          />
        </div>
      </div>

      <CardTabs class="card-tabs"
        v-model="state"
        :tabs="tabs"
      >
        <template #right>
          <TemporarilyDisaglePostNlButton/>
        </template>
      </CardTabs>
    </template>

    <template class="p12" #cell-status="{value}">
      <button
        type='button'
        class="btn"
        :class="value === 'active' ? 'btn-success' : 'btn-danger'"
      >
        {{ value }}
      </button>
    </template>

    <template class="p12" #cell-orderAmount="{value}">
      <span class="order-amount" style="color: #0081C9">
        {{ `€ ${(value + "").replace(/\./, ",")}` }}
      </span>
    </template>

    <template #cell-state="{value, item}">
      <div style="font-size: 16px" v-if="value.toUpperCase() === 'NOT_SENT'"><span class="badge badge-secondary">Nieuw / Niet verzonden</span></div>
      <div style="font-size: 16px" v-if="value.toUpperCase() === 'SENT_TO_POSTNL'"><span class="badge badge-warning">Verzonden naar PostNL</span></div>
      <div style="font-size: 16px" v-if="value.toUpperCase() === 'SHIPPED'"><span class="badge badge-success">Verstuurd naar klant</span></div>
      <div style="font-size: 16px" v-if="value.toUpperCase() === 'CANCELED'"><span class="badge badge-danger">Geannulleerd</span></div>
    </template>

    <template #cell-shipmentTrackAndTrace="{value, item}">
      <span v-if="!Array.isArray(value)" class="shipment-track-and-trace">
        <a @click.stop v-if="getTrackAndTraceLink(value, item)" :href="getTrackAndTraceLink(value, item)" target="_blank">{{ value }}</a>
        <span v-else>{{ value }}</span>
      </span>
      <div v-else @click.stop class="d-flex">
        <div class="shipment-track-and-trace">
          <a class="track-link" @click.stop v-if="getTrackAndTraceLink(value[0], item)" :href="getTrackAndTraceLink(value[0], item)" target="_blank">{{ value[0] }}</a>
          <span v-else>{{ value[0] }}</span>
        </div>

        <FormDropdown
          tag="div"
          :align-right="true"
          :remove-dropdown-tottle="true"
        >
          <template #title>
            <span class="extra-items">
              {{ value.length - 1 }}+
            </span>
          </template>

          <button
            v-for="link in value.slice(1)"

            class="dropdown-item"
            :key="link"
          >
            <a @click.stop v-if="getTrackAndTraceLink(link, item)" :href="getTrackAndTraceLink(link, item)" target="_blank">{{ link }}</a>
            <span v-else>{{ link }}</span>
          </button>
        </FormDropdown>
      </div>
    </template>

    <template class="p12" v-if="loaded" #row-action="{item}">
      <div>
        <TableActionDropdown class="drop" :item="item" :options="options(item, freshRefetch)"/>
      </div>
    </template>

    <template class="p12" #cell-orderNumber="{value}">
      <CopyableElement :skeleton-class="skeletonClass"
                       :value="value"
                       :message="`Succesvol ${value} ordernummer gekopieerd!`"
      >
        {{ value }}
      </CopyableElement>
    </template>

    <template class="p12" #cell-linked_order="{ value }">
      <CopyableElement :skeleton-class="skeletonClass"
                       :value="value"
                       :message="`Succesvol gekopieerde ${value} gekoppelde bestelling!!`"
      >
        {{ value }}
      </CopyableElement>
    </template>

    <template class="p12" #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen bestellingen"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
          <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
        </svg>
      </EmptyStatePlaceholder>
    </template>


  </TableTemplate>
</template>

<script>

import table from "src/mixins/table"

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import FormSelect from "src/components/Inputs/FormSelect.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import TableCell from "src/components/Table/TableCell.vue"
import TableDatePickerField from '../components/Inputs/TableDatePickerField.vue'
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import CopyableElement from '../layout/CopyableElement.vue'
import MultiplePageSizesSelection from '@/layout/Table/MultiplePageSizesSelection.vue'
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import FormSearchSelector from '../components/Inputs/FormSearchSelector.vue'
import CheckboxOptions from 'src/layout/Table/DropdownCheckboxTableFilters/CheckboxOptions.vue'
import keepScroll from "src/mixins/keepScroll"
import OrderListSummary from '../components/OrderOverview/OrderListSummary.vue'
import ShippingAddress from '../components/OrderOverview/ShippingAddress.vue'
import BillingAddress from '../components/OrderOverview/BillingAddress.vue'
import TemporarilyDisaglePostNlButton from '../components/OrderOverview/TemporarilyDisaglePostNlButton.vue'
import CardTabs from "@/layout/CardTabs"
import FormDropdown from "/src/components/FormDropdown.vue";

/*
  <div class="delete-icon cancel-icon" @click="confirmDelete(item)">
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  </div>
*/

const MILISECONDS_IN_TWO_DAYS = 172800000
const MILISECONDS_IN_THREE_DAYS = 259200000

export default {
  metaInfo: {
    title: "Bestellingen",
  },
  components: {
    TemporarilyDisaglePostNlButton,
    HeaderButton,
    TableHeader,
    TableMainSearchField,
    CardTabs,
    MultiplePageSizesSelection,
    TableCell,
    TableDatePickerField,
    CopyableElement,
    TableActionDropdown,
    FormSelect,
    TableTemplate,
    TableSearchField,
    BillingAddress,
    EmptyStatePlaceholder,
    FormDropdown,
    ShippingAddress,
    FormSearchSelector,
    OrderListSummary,
    CheckboxOptions
  },
  mixins: [
    tableFieldOptions,
    keepScroll,
    table({
      pageReference: 'overview-order',

      defaultColumnSizes: {
        orderDate: 140,
        orderNumber: 140,
      },
      disableAlphabeticalSort: true,
      columnTranslationMaps: {
        "Bestelnummer": "orderNumber",
        "Besteldatum": "orderDate",
        "Bestelbedrag": "orderAmount",
        "Klant": "customer",
        "Website": "site",
        "E-mail": "email",
        "Status": "state",
        "Track and Trace": "shipmentTrackAndTrace",
        "Gekoppelde bestelling": "linked_order",
        "Coupon code": "coupon_code",

        "Landcode": "countryCode",
        "Kortingen": "discounts",
        "Postcode": "postalCode",
        "Eindtotaal": "grand_total",
        "Product totaal": "product_total",
        "Verzending totaal": "shipping_total",
        "BTW": "vat",
      },
      defaultColumns: [
        'Besteldatum', 'Bestelnummer', "Bestelbedrag", "Klant", "Website", "E-mail", "Status", "Track and Trace"
      ],
      columnConfigurationId: "overview-order",
      parseParamsBeforeSending: params => {
        const initial = params.orderInitialDate
        const final = params.orderFinalDate

        delete params.orderInitialDate
        delete params.orderFinalDate

        return {
          ...params,
          orderDate: final ? [initial, final] : (initial && [initial]),
        }
      },
      defaultSort: "orderDate",
      defaultOrder: "desc",
      page_size: 100,
      params: {
        orderNumber: "",
        site: "",
        customer: "",
        orderAmount: "",
        search: "",
        email: "",
        state: undefined,
        orderInitialDate: "",
        orderFinalDate: "",
        page_size: 20,
      },
      toISOFields: ["orderInitialDate", "orderFinalDate"],
      route: "/api/orders",


      refetchHook: vm => vm.fetchOrdersMetaInfo()
    }),
  ],
  created() {
    this.fetchOrdersMetaInfo()
  },
  data() {
    return {
      meta: {},
      // Filters Data
      showFilters: false,
      // Checkbox Data
      selectedOrder: null,
      selectedOrderData: null,
      loadingOrder: false,
      activeColumnTab: "shipping-address",
      selectingWebsitesToFocus: [],
      online: [],

      /**
       * [ Mixin keepScroll ] - localStorageKey: Unique key(one per page) that will be used as a reference to set/get the element's distance from the top
       */
      localStorageKey: "position_scroll_overview_order"
    }
  },
  methods: {
    _showFilters() {
      this.showFilters = !this.showFilters
      console.log("This Filter have missing Figma Design")
    },

    selectOrder({ uid }) {
      this.selectedOrder = uid
    },
    async fetchOrder() {
      this.loadingOrder = true

      const { data } = await (await this.axios.get(`/api/orders/${this.selectedOrder}`))
      this.selectedOrderData = {...data, uid: this.selectedOrder}

      this.loadingOrder = false
    },
    async addOrder() {
      this.$pushModal({
        modal: "AddOrder",
        toBind: {
          callback: this.freshRefetch,
        }
      })
    },

    async fetchOrdersMetaInfo() {
      const states = ["NOT_SENT", "SENT_TO_POSTNL", "SHIPPED", "CANCELED"]
      const fetchTotal = async state => (await this.axios.get("/api/orders", {params: {state, site: this.site}})).data.total

      const meta = await Promise.all(states.map(async state => ({
        state,
        total: await fetchTotal(state),
      })))
      this.meta = meta.reduce((obj, {state, total}) => ({
        ...obj,
        [state]: total,
      }), {})
    },

    async cancelOrder(uid) {
      this.$handlePromise(
        this.axios.delete(`/api/orders/${uid}`)
      )
      this.$store.dispatch('clearCacheSearch', "orders")
      this.$success("Bestelling geannuleerd!")
      this.freshRefetch()
    },
    setWebsiteParam(item) {
      if(!item) return;
      const { domainname } = item
      this.site = domainname
      return domainname
    },
    viewOrder(item) {
      if (this.removeCursor) return;
      const referenceRowTarget = document.getElementById(`table-row-${item.uid}`)
      this.setLocalStorageTopDistance({ target: referenceRowTarget})

      this.$router.push(`/admin/order/${item.uid}`).catch(()=>{})
    },
    getWebsiteList(websites) {
      return websites.reduce((str, site) => {
        return !str.length ? `, ${site.domainname}` : site.domainname
      }, "")
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.cancelOrder(item.uid),
        {
          title: "Annuleer bestelling",
          description: `Are you sure you want to cancel the <b>${item.email || item.customer}</b> order?`,
          buttonSave: "Annuleren",
        }
      )
    },
    options(item, freshRefetch) {
      const editAndResend = {
        click: () => this.viewOrder(item),
        id: "edit-and-resend",
        name: "Wijzig en stuur opnieuw",
        icon: "nc-icon nc-settings-tool-66",
      }

      const viewOrder = {
        click: () => this.viewOrder(item),
        id: "view",
        name: "Order bekijken",
        icon: "nc-icon nc-zoom-split",
      }

      switch (item.state.toLowerCase()) {
        case "not_sent": {
          return [
            {
              click: () => this.viewOrder(item),
              id: "edit",
              name: "Wijzig order",
              icon: "nc-icon nc-settings-tool-66"
            },
            {
              click: async () => {
                this.$pushModal({
                  modal: "OverviewOrderMarkAsBeingShipped",
                  toBind: {
                    order: item,
                    callback: freshRefetch,
                  }
                })
              },
              id: "mark-as-being-shipped",
              name: "Markeren als verzonden naar Klant",
              icon: "nc-icon nc-map-big",
            },
            {
              click: async () => {
                if (await this.$handlePromise(
                  this.axios.delete(`/api/orders/${item.uid}`)
                )) {
                  this.$store.dispatch('clearCacheSearch', "orders")
                  this.$success("Bestelling geannuleerd!")
                  freshRefetch()
                }
              },
              id: "cancel",
              name: "Annuleer order",
              icon: "nc-icon nc-simple-remove",
            },
          ]
        }
        case "sent_to_postnl": {
          return [
            editAndResend,
            {
              click: async () => {
                this.$pushModal({
                  modal: "OverviewOrderMarkAsBeingShipped",
                  toBind: {
                    order: item,
                    callback: freshRefetch,
                  }
                })
              },
              id: "mark-as-being-shipped",
              name: "Markeren als verzonden naar Klant",
              icon: "nc-icon nc-map-big",
            },
          ]
        }
        case "shipped": {
          return [viewOrder]
        }
        case "canceled": {
          return [editAndResend]
        }
      }
    },
    isOlderThanTwoDays(orderDate) {
      const diff = new Date().getTime() - new Date(orderDate).getTime()
      return diff > MILISECONDS_IN_TWO_DAYS
    },
    isOlderThanThreeDaysInPostNl(item) {
      if (item.state === 'SENT_TO_POSTNL') {
        const diff = new Date().getTime() - new Date(item.orderDate).getTime()

        return diff > MILISECONDS_IN_THREE_DAYS
      }
      return false
    },
    getTrackAndTraceLink(trackingId, item) {
      const countryCode = item.countryCode
      const postalCode = item.postalCode;

      if (typeof trackingId !== 'string'
        || trackingId.length !== 13
        || !trackingId.toLowerCase().startsWith('3s')
        || !postalCode) {
        return false;
      }

      return `https://jouw.postnl.nl/track-and-trace/${trackingId}-${countryCode}-${postalCode}`
    },
  },
  computed: {
    availablePageSizeValues() {
      return [ 20, 50, 100 ]
    },

    shouldMakeTextsBold() {
      return this.state === "NOT_SENT" || this.state === "SENT_TO_POSTNL"
    },
    sortOptions() {
      return [
        {
          str: "Asc",
          value: "asc",
        },
        {
          str: "Desc",
          value: "desc",
        },
      ]
    },

    mappedOrders() {
      let arr = this.tableResult
      if (this.shouldMakeTextsBold) {
        arr = arr.map(item => ({
          ...item,
          isOlderThanTwoDays: this.isOlderThanTwoDays(item.orderDate),
        }))
      }

      return arr.map(item => ({
        ...item,
        isPrimary: item.linked_order ? true: false,
        isSuccess: item.coupon_code ? true : false,
        isDanger: this.isOlderThanThreeDaysInPostNl(item),
        isWarning: item.linked_order && item.discount ? true : false,
        shipmentTrackAndTrace: item.shipmentTrackAndTrace && item.shipmentTrackAndTrace.includes(';')
          ? item.shipmentTrackAndTrace.split(";")
          : item.shipmentTrackAndTrace
      }))
    },
    table() {
      return this.$refs.table
    },
    capitalize() {
      return [false, false, false, false, false, false, false]
    },

    tabs() {
      const meta = this.meta
      return [
        {
          name: "Alle bestellingen",
          id: undefined,
        },
        {
          name: "Nog niet verzonden",
          id: 'NOT_SENT',
        },
        {
          name: "Afgeleverd aan PostNL",
          id: 'SENT_TO_POSTNL',
        },
        {
          name: "Verzonden naar Klant",
          id: 'SHIPPED',
        },
        {
          name: "Geannuleerd",
          id: 'CANCELED',
        },
      ].map(item => ({...item, number: meta[item.id] || 0}));
    },

    totalPriceOfProducts() {
      return "---"
      return this.tableResult.reduce((tot, tableItem) => {
        return tot + tableItem.orders.reduce((tot, curr) => tot + (curr.price * curr.qty), 0)
      }, 0)
    },
    averageProductsPerOrder() {
      return "---"
      return this.tableResult.reduce((tot, curr) => tot + curr.orders.length, 0) / this.tableResult.length
    },
  },
  watch: {
    selectedOrder(uid) {
      if (uid) this.fetchOrder()
    },
    state() {
      this.page = 1
    }
  },
}

</script>

<style>

.table-cell.shipmentTrackAndTrace {
  overflow: visible;
}

.OverviewOrder tr > td.first-child > span {
  display: block;
  padding-left: 14px !important;
}
.p-12{
  padding: 12px;
}
.py-12{
  padding: 12px 0;
}
.px-12{
  padding: 0px 12px;
}

/* "selectedOrder" class="inner-radio">< */

.select-radio {
  display: block;
  width: 15px !important;
  height: 15px;
  margin-left: 4px;
  margin-top: 8px;
  border-radius: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid rgba(200, 200, 200);
  position: relative;
  z-index: 50;
}

.selectedOrder .select-radio.active {
  border: 1px solid var(--primary);
}

.select-radio.active .inner-radio {
  width: 7px;
  height: 7px;
  border-radius: 1000px;
  background-color: var(--primary);
}

.table-success {
  border-top: 1px solid  #8fd19e !important;
}
.table-success + tr {
  border-top: 1px solid  #8fd19e !important;
}
.table-success td {
  background-color: #b1dfbb !important;
}
.table-success:hover td {
  background-color:  #8fd19e !important;
}

.table-primary {
  border-top: 1px solid #7abaff !important;
}
.table-primary + tr {
  border-top: 1px solid #7abaff !important;
}
.table-primary td {
  background-color: #9fcdff !important;
}
.table-primary:hover td {
  background-color: #7abaff !important;
}
.table-danger {
  border-top: 1px solid #ed969e !important;
}
.table-danger + tr {
  border-top: 1px solid #ed969e !important;
}
.table-danger td {
  background-color: #f5c6cb !important;
}
.table-danger:hover td {
  background-color: #ed9ba4 !important;
}
.table-warning {
  border-top: 1px solid #ffdf7e !important;
}
.table-warning + tr {
  border-top: 1px solid #ffdf7e !important;
}
.table-warning td {
  background-color: #ffe8a1 !important;
}
.table-warning:hover td {
  background-color: #ffdf7e !important;
}
</style>

<style scoped>

.track-link {
  transform: translateY(3px);
  display: inline-block;
}

.extra-items {
  background-color: white;
  border: 1px solid rgb(240,240,240);
  padding: 4px 8px;
  border-radius: 4px;
}

.dropdown-item {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.overview-order {
  margin-top: -2px;
}

.blueish{
  color: #0081C9 !important;
}
.filter-button:hover{
  color: #ffffff;
  background-color: #7a868f;
}

.item {
  transition-duration: .15s;
}

.item:hover {
  background-color: rgba(245,245,245);
}

.older-than-two-days-warning {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.card-tabs {
  transform: translateY(9px);
}

.card-title {
  margin-top: 0;
  margin-bottom: 18px;
}

.website-search {
  width: 100%;
}

.website-search::v-deep input {
  height: 34px;
}

@media (min-width: 992px) {
  .website-search {
    width: initial;
  }
}
@media (max-width: 600px) {
  /* .header-btn-res{
    font-size: 8px;
    padding: 4px 5px;
  } */
  .table-header-res{
    display: flex;
    flex-direction: column;
  }
  .checkbox-res{
    display: none;
  }
}

.shipment-track-and-trace a,
.shipment-track-and-trace span {
  display: inline-block;
  padding: 5px;
  margin-left: -5px;
}

</style>
